import React, { useState } from 'react';
import Sidebar_Progress from "../../../layouts/Operational_Sidebar_Progress.component";
import customer from '../../../../img/customer-review.png'
// import NozzleEmpModal from './NozzleAlloEmplist.component'
import ReactDOM from 'react-dom';
import { API_URL } from "../../../../constant/API_Settings";
import swal from "sweetalert";
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { Link } from "react-router-dom";
import Modal from "react-modal";
// import NozzleEmpModal from './NozzleEmpModal.component';
import SummarySheet from '../SummarySheet.component';
import TabHeader from '../TabHeader.component';
import NozzleEmpModal from './NozzleEmpModal1.component'
import DesignConfigModal from './Designdemo.component';
import LoginHeaderOperational from '../../LoginHeaderOperational';
import Loader from '../Loader.component'
import { preventNonNumericalInput } from '../../../layouts/Operational_Sidebar_Progress.component';
import { NOZZLE_READING_DECIMALS, toFixedNozzleReading } from '../../../../utils/nozzleReadingPrecision';
import moment from 'moment';
import { applyCheckUrlNavigation } from '../../../../utils/checkUrlNavigation';
import { formatReportTime } from '../../../../utils/dailyTransactionFuelSalesRows';
import {
	formatNozzleClock,
	resolveNozzleEndClock,
	resolveNozzleStartClock,
	sameDayNozzleCloseTimeError,
} from '../../../../utils/nozzleClosingTime';
const format = 'HH:mm '

const isNonNegativeNumber = (value) =>
	value !== null && value !== undefined && value !== '' && !Number.isNaN(Number(value)) && Number(value) >= 0;

const toFixedNumberString = (value, digits = 2) => {
	const parsed = parseFloat(value);
	return Number.isFinite(parsed) ? parsed.toFixed(digits) : (0).toFixed(digits);
};

/**
 * Match single-nozzle closing: round quantity to 2dp, then amount = qty * price (2dp).
 * Supports mid-shift price split via b_opening_reading / b_selling_price when present.
 */
const calcRoundedNozzleSale = ({
	closingReading,
	openReading,
	price,
	bOpeningReading = '',
	bSellingPrice = '',
}) => {
	const closing = parseFloat(toFixedNozzleReading(closingReading));
	const opening = parseFloat(openReading);
	if (!Number.isFinite(closing) || !Number.isFinite(opening)) {
		return { quantity: '', amount: '' };
	}

	let qtyRaw = closing - opening;
	if (qtyRaw < 0) {
		qtyRaw = 0;
	}
	const quantity = toFixedNumberString(qtyRaw, 2);
	const qtyNum = parseFloat(quantity) || 0;

	const sellPrice = parseFloat(price);
	const hasSplit =
		bOpeningReading !== '' &&
		bOpeningReading != null &&
		bSellingPrice !== '' &&
		bSellingPrice != null &&
		Number.isFinite(parseFloat(bOpeningReading)) &&
		Number.isFinite(parseFloat(bSellingPrice)) &&
		Number.isFinite(sellPrice);

	let amountRaw = 0;
	if (hasSplit) {
		const bOpen = parseFloat(bOpeningReading);
		const bPrice = parseFloat(bSellingPrice);
		if (closing <= bOpen) {
			amountRaw = qtyNum * bPrice;
		} else {
			const bQty = bOpen - opening;
			const afterQty = closing - bOpen;
			amountRaw = (bPrice * bQty) + (sellPrice * afterQty);
		}
	} else if (Number.isFinite(sellPrice)) {
		amountRaw = qtyNum * sellPrice;
	}

	return {
		quantity,
		amount: toFixedNumberString(amountRaw, 2),
	};
};

const NozzleEmp = (props) => ReactDOM.createPortal(
	<NozzleEmpModal  {...props} />, document.body
);

const NozzleEmpDesign = (props) => ReactDOM.createPortal(
	<DesignConfigModal  {...props} />, document.body
);

const NozzleEmpConfig = (props) => {

	const [delete_id, deleteId] = useState([])
	const [summary, setSummary] = useState([])


	const [input, setInputs] = useState([])
	const [total, setTotal] = useState([])
	const [single_id, setSid] = useState('')
	const [inputValues, setInputValues] = useState({ vehicle_no: [''] });
	const [fields, setFields] = useState(['']);
	const history = useHistory()
	const [search, setSearch] = useState('')
	const [list_data, setList] = useState([])
	const [selling_price, setPrice] = useState({})
	const [product_id, setProduct] = useState({})
	const [opening_reading, setOpeningReading] = useState({})
	const [errors, setErrors] = useState({ vehicle_no: [''] })
	const [double, setDouble] = useState(true);
	const [change, setChange] = useState(true);
	const [changestarttime, setchangestarttime] = useState(true);
	const [changeendtime, setchangeendtime] = useState(true);
	const [timePickerClicked, setTimePickerClicked] = useState(false);
	const [cursorPosition, setCursorPosition] = useState(0);
	const [isTimePickerClosedstart, setIsTimePickerClosedstart] = useState(false);
	const [isTimePickerClosedend, setIsTimePickerClosedend] = useState(false);
	const [startendtap, setstartendtap] = useState(false);
	const [permission, setPermission] = useState([])
	const [mulerror, setMulerror] = useState([]);
	const [Values, setValues] = useState([])
	const [Valuess, setValuess] = useState([])
	const [equaldates, setequaldates] = useState(true);
	const [endDate, setEndDate] = useState('');
	const [pages, setpages] = useState(
		{
			current_page: 1,
			last_page: 0,
			total_pages: 0,
			pagination_item: [],
			total_pages: 0,
		})


		const handleFocus = (event) => {
			if (event.target.selectionStart) {
				
			} 
		};

		const handleBlur = (event) => {
			// alert("bnbnbn")
			
		};

		/** Format Close All numeric fields after typing so multi-digit entry works. */
		const handleCloseAllFieldBlur = (i, e) => {
			const name = e?.target?.name;
			if (!name || !['quantity', 'clossing_reading', 'amount'].includes(name)) {
				return;
			}
			const raw = e.target.value;
			if (raw === '' || raw == null) {
				return;
			}
			let formatted = raw;
			if (name === 'quantity' || name === 'amount') {
				formatted = toFixedNumberString(raw, 2);
			} else if (name === 'clossing_reading') {
				formatted = toFixedNozzleReading(raw);
			}
			if (String(formatted) === String(raw)) {
				return;
			}
			handleAmount(i, { target: { name, value: formatted } });
		};
	
	    const handleClose = (i,type) => {
		//  alert(type)
		let Closetime = []
		let change = false;
		let endchange =false;
		Closetime =[...Values]
		let oldtime=[]
		oldtime=[...Valuess]

		if(Closetime[i]['sent_start_from'] != oldtime[i]['sent_start_from']){
			change = true
			

		}

		if(Closetime[i]['sent_end_from'] != oldtime[i]['sent_end_from']){
			endchange = true
			

		}
		
        // console.log(Closetime[i]["sent_start_from"],"bbbbbbbbbbbbb")
		if(type == "start" && change == true){
			// alert(1)
			setchangestarttime(false)
			setIsTimePickerClosedstart(true)

		}else if(type == "end" && endchange == true ){
			// alert(2)
			setchangeendtime(false)
			setIsTimePickerClosedstart(true)
		}
		// setIsTimePickerClosed(true);
		
				  };
				

				
	const handleInput = (value) => {
	
		let endstartdate=inputValues.op_date;
		let endstarttime=formatNozzleClock(inputValues.show_start_from, 'HH:mm')
			|| formatNozzleClock(inputValues.start_from, 'HH:mm');
		let endendDate=inputValues.endDate;
		let endendtime=formatNozzleClock(value, 'HH:mm');
		let formIsValid = true;


		if(endstartdate && endstarttime && endendDate && endendtime){

				formIsValid = true
				if((endendtime < endstarttime) 
				&& (endendDate == endstartdate)
				){
				
					errors["end_from"] ="On same date,End time should be greater than start time";
					formIsValid = false
					setDouble(true)
					
				}else{
					errors["end_from"]="";
					errors["show_start_from"]="";

				}
				if(formIsValid == true){

	const endtrimmedStartTime = endstarttime.trim();
	const endstartTimeWithSeconds = `${endtrimmedStartTime}:00`;
	const endstartDateTimeString = `${endstartdate}T${endstartTimeWithSeconds}`;
	const endstartDateTime = new Date(endstartDateTimeString);

	
	const endtrimmedendtTime = endendtime.trim();
	const endendTimeWithSeconds = `${endtrimmedendtTime}:00`;
	const endendDateTimeString = `${endendDate}T${endendTimeWithSeconds}`;
	const endendDateTime = new Date(endendDateTimeString);

	const endtimeDifference = Math.abs(endendDateTime - endstartDateTime);
	const endtotalHours = Math.floor(endtimeDifference / (1000 * 60 * 60));
	const endtotalMinutes = Math.floor((endtimeDifference % (1000 * 60 * 60)) / (1000 * 60));
	inputValues['total_hr'] = endtotalHours;
	inputValues['total_min'] = endtotalMinutes;

}else{
		inputValues['total_hr']=0;
		inputValues['total_min'] =0;
	}}

		setInputValues({
			...inputValues,
			end_from: value
		})

		if (formIsValid === true && inputValues.id) {
			refreshClosingPrice(inputValues.id, value, endendDate);
		}

		

	};
	
	const handlestartInput = (values) => {



			
			let inputstartdate=inputValues.op_date;
			let inputstarttime=formatNozzleClock(values, 'HH:mm');
			let inputendDate=inputValues.endDate;
			let inputendtime=formatNozzleClock(inputValues.end_from, 'HH:mm')
				|| formatNozzleClock(inputValues.sugest_end_from, 'HH:mm');


			if(inputstartdate && inputstarttime && inputendDate && inputendtime){

				let formIsValid = true
				if((inputendtime < inputstarttime) 
				&& (inputendDate == inputstartdate)
				){
				
					errors["show_start_from"] ="On the same date, the starttime should come before the endtime.";
					formIsValid = false
					setDouble(true)
					
				}else{
					errors["show_start_from"]="";
					errors["end_from"]="";
				}
				if(formIsValid == true){

		const inputtrimmedStartTime = inputstarttime.trim();
        const inputstartTimeWithSeconds = `${inputtrimmedStartTime}:00`;
		const inputstartDateTimeString = `${inputstartdate}T${inputstartTimeWithSeconds}`;
        const inputstartDateTime = new Date(inputstartDateTimeString);

		
		const inputtrimmedendtTime = inputendtime.trim();
        const inputendTimeWithSeconds = `${inputtrimmedendtTime}:00`;
		const inputendDateTimeString = `${inputendDate}T${inputendTimeWithSeconds}`;
        const inputendDateTime = new Date(inputendDateTimeString);

        const inputtimeDifference = Math.abs(inputendDateTime - inputstartDateTime);
		const inputtotalHours = Math.floor(inputtimeDifference / (1000 * 60 * 60));
		const inputtotalMinutes = Math.floor((inputtimeDifference % (1000 * 60 * 60)) / (1000 * 60));
		inputValues['total_hr'] = inputtotalHours;
		inputValues['total_min'] = inputtotalMinutes;

				}else{
					inputValues['total_hr']=0;
					inputValues['total_min'] =0;
				}}
		setInputValues({
			...inputValues,
			show_start_from: values,
	
		})
	

		// calculatetotalhrs();
	};
	//loader
	const [Loading, setLoading] = useState(false);
	//---On Load---//		
	useEffect(() => {

		check_url()
	}, []);


	// useEffect(() => {

	// 	// calculatehours();
	// }, [inputValues]);




	function getSummerySheet() {
		const requestOptions = {
			method: 'post',
			body: JSON.stringify({
				op_emp_id: localStorage.getItem('op_emp_id'),
				emp_id: localStorage.getItem('emp_id'),
				op_date: localStorage.getItem('op_date'),
			}),

			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"

			},
		};
		fetch(API_URL + "/getSummerySheet", requestOptions)
			.then(response => { return response.json(); })
			.then(responseData => {
				setSummary(responseData)
				return responseData;
			})
			.catch(e => {
				console.error("[NozzleAllocation] summary fetch failed", e);

			});
	}
	function check_meta_date() {

		const requestOptions = {
			method: 'post',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"

			}
		};
		fetch(`${API_URL}/check_meta_date`, requestOptions)
			.then(response => { return response.json(); })
			.then(responseData => {
				if (!responseData.op_date || !localStorage.getItem('emp_id') || !localStorage.getItem('op_date')) {
					history.push("/nozzle-employee-list");
				}
				else {

					//setInputs({ ...input, op_date: responseData.op_date })
					ListNozzleAllocation(pages.current_page, localStorage.getItem('op_date'))
					getSummerySheet()

				}

				return responseData;
			})
			.catch(e => {
			});

	}
	function ListNozzleAllocation(page, date) {

		const requestOptions = {
			method: 'post',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"

			}, body: JSON.stringify({
				op_date: date,
				n_emp_id: localStorage.getItem("op_emp_id"),
				emp_id: localStorage.getItem("emp_id"),
				search_keyword: search
			})
		};
		fetch(`${API_URL}/get_nozzle_allocation?search_keyword=${search}&page=${page}`, requestOptions)
			.then(response => { return response.json(); })
			.then(responseData => {
				if (responseData.status == 3) {
					setPermission({ ...permission, status: responseData.status, message: responseData.message })
				}
				else {
					setList(responseData.data.data)

					responseData.data.data.map((obj,index) => {
              if(index==0) {
				setSid(obj.id)
			  }
					
						
					}
					)
					setTotal({
						...total,
						totalamount: responseData.totalamt,
					})

					
					const mla = responseData.mla_coupon_status
					const fleet = responseData.fleet_card_status
					const shift_time = responseData.shift_time

					
					localStorage.setItem('mla_status', mla);
					localStorage.setItem('fleet_status', fleet);
					localStorage.setItem('shift_time', shift_time);

					var total_pages = responseData.data.last_page

					var items = []
					for (let number = 1; number <= total_pages; number++) {
						number === page ? items.push(
							<li key={number} className="page-item active"><a className="page-link" onClick={() => handlePagination(number)}>{number}</a></li>
                      ,) : items.push(
								<li key={number} className="page-item"><a className="page-link" onClick={() => handlePagination(number)}>{number}</a></li>
                      ,)
					}

					setpages({
						...pages,
						current_page: responseData.data.current_page,
						last_page: responseData.data.last_page,
						total_pages: responseData.data.last_page,
						pagination_items: items
					})
				}
				
				setLoading(true);
				return responseData;
			})
			.catch(e => {


			});
	}
	const handlePagination = (number) => {
		setpages({
			...pages,
			current_page: number        //---pagination---//
		}
		)

		ListNozzleAllocation(number, localStorage.getItem('op_date'))
	}
	//---Create popup function---//
	const UseModal = () => {

		const [isShowing, setIsShowing] = useState(false);
		const [isShowing1, setIsShowing1] = useState(false);

		function toggle() {
			if (isShowing) {
				setInputValues({})
				setOpeningReading({})
				setErrors({})
				setFields([''])
			}
			if (!isShowing) {

				setErrors({})
				setDouble(true)
			}
			setIsShowing(!isShowing);
		}

		
		function toggle_allnozzle() {
			if (isShowing1) {
				// alert("nnnnnnnnnnnn")
				setInputValues({})
				setOpeningReading({})
				// setErrors({})
				setMulerror([])
				setFields([''])
				setChange(true)
				setchangestarttime(true)
				setchangeendtime(true)
				setIsTimePickerClosedstart(false)
				setIsTimePickerClosedend(false)
				// setIsTimePickerClosed(false)
				setCursorPosition(0);
				
			}
			if (!isShowing1) {

				setErrors({})
				setDouble(true)
			}
			setIsShowing1(!isShowing1);
		}

		return {
			isShowing,
			toggle,
			isShowing1,
			toggle_allnozzle,
		}
	};
	const { isShowing, toggle } = UseModal();
	const { isShowing1, toggle_allnozzle } = UseModal();

	inputValues['product_id'] = product_id.product_id;
	inputValues['current_stock'] = inputValues.current_stock;
	inputValues['price'] = inputValues.price ? inputValues.price: selling_price.price;
	// inputValues['end_from'] = inputValues.end_from;
	// inputValues['sugest_end_from'] = inputValues.sugest_end_from;
	inputValues['nozzle_status'] = inputValues.nozzle_status;
	inputValues['nz_count'] = inputValues.nz_count;
	inputValues['nz_close_reading'] = inputValues.nz_close_reading;
	inputValues['closing_stock'] = inputValues.closing_stock;
	// inputValues['start_from']=inputValues.start_from;
	// inputValues['show_start_from']=inputValues.show_start_from;


	const handleInputs = (e) => {
		
		let errors = []
		let formIsValid = true
		var quantity_saved = inputValues['quantity'];

		if (e.target.name == "clossing_reading") {
			const closingReading = parseFloat(toFixedNozzleReading(e.target.value));
			inputValues['clossing_reading'] = toFixedNozzleReading(e.target.value);
			var quantity = closingReading - opening_reading.reading ? closingReading - opening_reading.reading : 0
			if (quantity < 0) {
				quantity = 0;
			}
			
			var q = parseFloat(quantity) ? parseFloat(quantity).toFixed(2) : 0;
			if (Number(inputValues['current_stock']) < Number(q)) {
				//	formIsValid = false;
				errors["quantity"] = "Insufficient Quantity of fuel in the tank"
			}
			else {
				errors["quantity"] = ""
			}
			
			if (((closingReading) <= (inputValues.b_opening_reading)) && (selling_price.price != '') && (inputValues.b_opening_reading != '') && (inputValues.b_selling_price != '')) {
				inputValues['quantity'] = parseFloat(q) ? parseFloat(q).toFixed(2) : 0;
				var amount = q * inputValues.b_selling_price;
				inputValues['amount'] = parseFloat(amount) ? parseFloat(amount).toFixed(2) : 0;
			}
			else if ((closingReading > inputValues.b_opening_reading) && (selling_price.price != '') && (inputValues.b_opening_reading != '') && (inputValues.b_selling_price != '')) {
				var b_qty = inputValues.b_opening_reading - opening_reading.reading ? inputValues.b_opening_reading - opening_reading.reading : 0
				inputValues['quantity'] = parseFloat(q) ? parseFloat(q).toFixed(2) : 0;
				var total_b_qty = inputValues.b_selling_price * b_qty;

				var qty = closingReading - inputValues.b_opening_reading ? closingReading - inputValues.b_opening_reading : 0
				var total_qty = selling_price.price * qty;

				var t_amount = total_b_qty + total_qty;
				inputValues['amount'] = parseFloat(t_amount) ? parseFloat(t_amount).toFixed(2) : 0
			}
			else if (selling_price.price) {
				inputValues['quantity'] = parseFloat(q) ? parseFloat(q).toFixed(2) : 0;
				var amount = q * selling_price.price;
				inputValues['amount'] = parseFloat(amount) ? parseFloat(amount).toFixed(2) : 0
			}
			else {
			}
		}
		else if (e.target.name == "amount") {

			if (selling_price.price && inputValues.b_selling_price != '') {

				var amount = e.target.value;
				var q = amount / inputValues.b_selling_price;

				var closereading = Number(opening_reading.reading) + Number(q);

				if (closereading <= inputValues.b_opening_reading) {
					inputValues['quantity'] = parseFloat(q) ? parseFloat(q).toFixed(2) : 0;
					inputValues['clossing_reading'] = parseFloat(closereading) ? parseFloat(closereading).toFixed(NOZZLE_READING_DECIMALS) : 0;
				}
				else if (closereading > inputValues.b_opening_reading) {
					var o_qty = inputValues.b_opening_reading - opening_reading.reading;

					var o_qty_amount = o_qty * inputValues.b_selling_price;
					var r_amt = amount - o_qty_amount;
					var r_qty = r_amt / selling_price.price;
					var quantity = Number(o_qty) + Number(r_qty);
					var clossing_reading = Number(opening_reading.reading) + Number(o_qty) + Number(r_qty);

					inputValues['quantity'] = parseFloat(quantity) ? parseFloat(quantity).toFixed(2) : 0;
					inputValues['clossing_reading'] = parseFloat(clossing_reading) ? parseFloat(clossing_reading).toFixed(NOZZLE_READING_DECIMALS) : 0;

				}
			}
			else if (selling_price.price && inputValues.b_selling_price == '') {

				var amount = e.target.value;
				var q = amount / selling_price.price;

				var closereading = Number(opening_reading.reading) + Number(q);

				inputValues['quantity'] = parseFloat(q) ? parseFloat(q).toFixed(2) : 0;
				inputValues['clossing_reading'] = parseFloat(closereading) ? parseFloat(closereading).toFixed(NOZZLE_READING_DECIMALS) : 0;

			}

		}
		else if (e.target.name == "quantity") {

			var closereading = Number(opening_reading.reading) + Number(e.target.value);
			inputValues['clossing_reading'] = parseFloat(closereading) ? parseFloat(closereading).toFixed(NOZZLE_READING_DECIMALS) : 0;


			var quantity = e.target.value;
			var q = parseFloat(quantity) ? parseFloat(quantity).toFixed(2) : 0;
			if (Number(inputValues['current_stock']) < Number(q)) {
				//formIsValid = false;
				errors["quantity"] = "Insufficient Quantity of fuel in the tank"
			}
			else {
				errors["quantity"] = ""
			}
			if (((closereading) <= (inputValues.b_opening_reading)) && (selling_price.price != '') && (inputValues.b_opening_reading != '') && (inputValues.b_selling_price != '')) {

				var amount = q * inputValues.b_selling_price;
				inputValues['amount'] = parseFloat(amount) ? parseFloat(amount).toFixed(2) : 0
			}
			else if ((closereading > inputValues.b_opening_reading) && (selling_price.price != '') && (inputValues.b_opening_reading != '') && (inputValues.b_selling_price != '')) {
				var b_qty = inputValues.b_opening_reading - opening_reading.reading ? inputValues.b_opening_reading - opening_reading.reading : 0

				var total_b_qty = inputValues.b_selling_price * b_qty;

				var qty = e.target.value - inputValues.b_opening_reading ? inputValues['clossing_reading'] - inputValues.b_opening_reading : 0

				var total_qty = selling_price.price * qty;

				var t_amount = total_b_qty + total_qty;
				inputValues['amount'] = parseFloat(t_amount) ? parseFloat(t_amount).toFixed(2) : 0
			}
			else if (selling_price.price) {
				var amount = q * selling_price.price;
				inputValues['amount'] = parseFloat(amount) ? parseFloat(amount).toFixed(2) : 0
			}
			else {
			}
		}

		if (inputValues['end_from'] == null) {
			inputValues['end_from'] = inputValues['sugest_end_from'];
		}
	



		if(e.target.name == "endDate"){

			
			let startstartdate=inputValues.op_date;
			let startstarttime=formatNozzleClock(inputValues.show_start_from, 'HH:mm')
				|| formatNozzleClock(inputValues.start_from, 'HH:mm');
			let startendDate=e.target.value;
			let startendtime=formatNozzleClock(inputValues.end_from, 'HH:mm')
				|| formatNozzleClock(inputValues.sugest_end_from, 'HH:mm');



		const SingletrimmedStartTime = startstarttime.trim();
        const singlestartTimeWithSeconds = `${SingletrimmedStartTime}:00`;
		const singlestartDateTimeString = `${startstartdate}T${singlestartTimeWithSeconds}`;
        const singlestartDateTime = new Date(singlestartDateTimeString);

		
		const SingletrimmedendtTime = startendtime.trim();
        const singleendTimeWithSeconds = `${SingletrimmedendtTime}:00`;
		const singleendDateTimeString = `${startendDate}T${singleendTimeWithSeconds}`;
        const singleendDateTime = new Date(singleendDateTimeString);

        const singletimeDifference = Math.abs(singleendDateTime - singlestartDateTime);
		const singletotalHours = Math.floor(singletimeDifference / (1000 * 60 * 60));
		const singletotalMinutes = Math.floor((singletimeDifference % (1000 * 60 * 60)) / (1000 * 60));
		inputValues['total_hr'] = singletotalHours;
		inputValues['total_min'] = singletotalMinutes;

		// setInputValues({
		// 	...inputValues,
		// 	[e.target.name]: e.target.value
		// });
		// NozzleAmount[i]["total_hr"]=totalHours;
		// NozzleAmount[i]["total_min"]=totalMinutes;
	    // const singleformattedDifference = `${singletotalHours}hr ${singletotalMinutes}min`;
		//  console.log(singleformattedDifference,"singleformattedDifference")
		//  NozzleAmount[i]["total_diff"]=formattedDifference;

		
		}

		setInputValues({
			...inputValues,
			[e.target.name]: e.target.value
		});

		if (e.target.name === "endDate" && inputValues.id && inputValues.end_from) {
			refreshClosingPrice(inputValues.id, inputValues.end_from, e.target.value);
		}

		
		// calculatetotalhrs();

	};
	
	// function handleInput1() {
	// }
	// function handleAmount() {
	// }



	const handleEndDateChange = (i,event) => {
		setEndDate(event.target.value);
	  };

	const handleInput1 = (i, e) => {

		var product_list = []

		product_list = [...Values]
		product_list[i][e.target.name]=e.target.value;
		setValues(product_list)
        // console.log(Values,"updated")
		// console.log("name",e.target.name,"value",e.target.value,"index",i)
	};



	const handleAmount =(i,e,type=null) =>{

		
	

		let NozzleAmount = []
		NozzleAmount =[...Values]
		
		
		if(e.target){
			NozzleAmount[i][e.target.name]=e.target.value;
				 	// console.log(e.target.name ,"datefromdatefrom")
			if(e.target.name =='clossing_reading'){
				// Keep raw digits while typing; format on blur. Immediate toFixed
				// blocked multi-digit entry (e.g. "1" → "1.000").
				const raw = e.target.value;
				NozzleAmount[i][e.target.name] = raw;
				const closingReading = parseFloat(raw);
				if (!Number.isFinite(closingReading)) {
					NozzleAmount[i]["quantity"] = '';
					NozzleAmount[i]["amount"] = '';
					setValues(NozzleAmount);
					return;
				}

				const sale = calcRoundedNozzleSale({
					closingReading,
					openReading: NozzleAmount[i]["open_reading"],
					price: NozzleAmount[i]["price"],
					bOpeningReading: NozzleAmount[i]["b_opening_reading"],
					bSellingPrice: NozzleAmount[i]["b_selling_price"],
				});
				NozzleAmount[i]["quantity"] = sale.quantity;
				NozzleAmount[i]["amount"] = sale.amount;
	     		let array =NozzleAmount;
			    let indexvalue =i;
		    	let CurrentArrayValue =array[indexvalue];
			    for (let q = indexvalue+1; q < array.length;q++)
				{
				let NextValue = array[q];
				if(NextValue.nozzle_id == CurrentArrayValue.nozzle_id && 
					NextValue.id > CurrentArrayValue.id &&
					 NextValue.nz_count == ''){
					NozzleAmount[q]["open_reading"]= toFixedNozzleReading(closingReading);
		            let sub_sub = parseFloat(NozzleAmount[q]["clossing_reading"]) - closingReading
				if(sub_sub <0){
					sub_sub=0;
				}
				if(sub_sub >= 0 && NozzleAmount[q]["clossing_reading"] !== '' && NozzleAmount[q]["clossing_reading"] != null){
					const nextSale = calcRoundedNozzleSale({
						closingReading: NozzleAmount[q]["clossing_reading"],
						openReading: closingReading,
						price: NozzleAmount[q]["price"],
						bOpeningReading: NozzleAmount[q]["b_opening_reading"],
						bSellingPrice: NozzleAmount[q]["b_selling_price"],
					});
					NozzleAmount[q]["quantity"] = nextSale.quantity;
					NozzleAmount[q]["amount"] = nextSale.amount;
				}else{
					NozzleAmount[q]["quantity"] = '';
					NozzleAmount[q]["amount"]   = '';
				}
				
				}


			}
	// /***********/ 



			}
	
			if(e.target.name == 'quantity'){
				// Keep raw digits while typing; format on blur. Immediate toFixed(2)
				// blocked multi-digit qty (e.g. "1" → "1.00", then "12" became impossible).
				const raw = e.target.value;
				NozzleAmount[i]["quantity"] = raw;
				const qty = parseFloat(raw);
				if (!Number.isFinite(qty)) {
					NozzleAmount[i]["amount"] = '';
					setValues(NozzleAmount);
					return;
				}
				let add = qty + parseFloat(NozzleAmount[i]["open_reading"] || 0)
				NozzleAmount[i]["clossing_reading"] = toFixedNozzleReading(add);
				const qtySale = calcRoundedNozzleSale({
					closingReading: NozzleAmount[i]["clossing_reading"],
					openReading: NozzleAmount[i]["open_reading"],
					price: NozzleAmount[i]["price"],
					bOpeningReading: NozzleAmount[i]["b_opening_reading"],
					bSellingPrice: NozzleAmount[i]["b_selling_price"],
				});
				NozzleAmount[i]["amount"] = qtySale.amount;

/**************/ 
        let arraiii =NozzleAmount;


        let indexvalue =i;

		let CurrentArrayValue =arraiii[indexvalue];

		for (let k = indexvalue+1; k < arraiii.length;k++){
			let NextValue = arraiii[k];
			if(NextValue.nozzle_id == CurrentArrayValue.nozzle_id && 
				NextValue.id > CurrentArrayValue.id &&
				 NextValue.nz_count == ''){
				
				// NozzleAmount[k]["open_reading"]=;
                if(Number(add)<=0|| isNaN(Number(add))){
					NozzleAmount[k]["open_reading"]=0;

				
				}else{
					NozzleAmount[k]["open_reading"]= toFixedNozzleReading(add);
				}

				if(NozzleAmount[k]["clossing_reading"] >= NozzleAmount[k]["open_reading"]){
					const chainedSale = calcRoundedNozzleSale({
						closingReading: NozzleAmount[k]["clossing_reading"],
						openReading: NozzleAmount[k]["open_reading"],
						price: NozzleAmount[k]["price"],
						bOpeningReading: NozzleAmount[k]["b_opening_reading"],
						bSellingPrice: NozzleAmount[k]["b_selling_price"],
					});
					NozzleAmount[k]["quantity"] = chainedSale.quantity;
					NozzleAmount[k]["amount"] = chainedSale.amount;
				}else{
				NozzleAmount[k]["quantity"] = '';
				NozzleAmount[k]["amount"]   = '';


			}
				
			


				 }
				}
/***************/ 

			}
	
			if(e.target.name == 'amount'){
						 	// console.log(e.target.name ,"datefromdatefrom")

				let t_price = parseFloat(e.target.value) / parseFloat(NozzleAmount[i]["price"])
				NozzleAmount[i]["quantity"] = parseFloat(t_price).toFixed(2);
			let CloseRead =	parseFloat(NozzleAmount[i]["quantity"]) + parseFloat(NozzleAmount[i]["open_reading"])
			if(CloseRead < 0){
				NozzleAmount[i]["clossing_reading"] = '';
			}else{
				NozzleAmount[i]["clossing_reading"] = parseFloat(toFixedNozzleReading(CloseRead));
			}
				
	
			}

			let amoi =NozzleAmount;
   
   
		   let indexvalue =i;
   
		   let CurrentArrayValue =amoi[indexvalue];

		   for (let p = indexvalue+1; p< amoi.length;p++){
			let NextValue = amoi[p];
			if(NextValue.nozzle_id == CurrentArrayValue.nozzle_id && 
				NextValue.id > CurrentArrayValue.id &&
				 NextValue.nz_count == ''){
				
				// NozzleAmount[p]["open_reading"]=NozzleAmount[i]["clossing_reading"];
				if(NozzleAmount[i]["clossing_reading"] == 0|| isNaN(NozzleAmount[i]["clossing_reading"])){
					NozzleAmount[p]["open_reading"]=0;

				
				}else{
					NozzleAmount[p]["open_reading"]=NozzleAmount[i]["clossing_reading"];
				}
				if(NozzleAmount[p]["clossing_reading"] >= NozzleAmount[p]["open_reading"]){
					const chainedFromAmount = calcRoundedNozzleSale({
						closingReading: NozzleAmount[p]["clossing_reading"],
						openReading: NozzleAmount[p]["open_reading"],
						price: NozzleAmount[p]["price"],
						bOpeningReading: NozzleAmount[p]["b_opening_reading"],
						bSellingPrice: NozzleAmount[p]["b_selling_price"],
					});
					NozzleAmount[p]["quantity"] = chainedFromAmount.quantity;
					NozzleAmount[p]["amount"]= chainedFromAmount.amount;
				}else{
				NozzleAmount[p]["quantity"] = '';
				NozzleAmount[p]["amount"]   = '';


			}
			
			}


		}
		// ..........
		// if(e.target.name =="sugest_end_from"){
		// 	// let datefrom=NozzleAmount;
		// 	console.log(e.target.name ,"datefromdatefrom")
		// }

		// .................
		if(e.target.name =="endDate"){
			// console.log(e.target.name ,"datefromdatefrom")

			let datearray = NozzleAmount;
            let indexdate =i;
   
		   let Currentindxdate =datearray[indexdate];
			
		    

		   for (let u = 0; u < datearray.length; u++) {
		   
			   let selecteddate = e.target.value;
		   
			   if (
				//    ( datearray[u]["quantity"] == null || datearray[u]["quantity"] == undefined) &&
				     change == true 
					//  && datearray[u]["quantity"] == null || datearray[u]["quantity"] == undefined
					 &&
				   (u != i)
				   && (datearray[u]["end_date"] == null || datearray[u]["end_date"] ==undefined)
			   ) {
				   datearray[u]['endDate'] = selecteddate;
				
				   
			   }
			
			   
		   }
		   setChange(false)
		  
		  
		
		}
	
		
		
	}
		else{
			
			if(type=="show_start_from"){
				
				NozzleAmount[i]["show_start_from"]=e;
				NozzleAmount[i]["sent_start_from"]=e.format(format);
				let datearraystarttime = NozzleAmount;
				let indexstarttimee =i;
				let Currentindxstarttime =datearraystarttime[indexstarttimee];
                for (let p = 0; p < datearraystarttime.length; p++) {
                let defaultstarttime =e;
				
				if (
					changestarttime == true &&  isTimePickerClosedstart != true && (p != i)
					   && (datearraystarttime[p]["end_date"] == null || datearraystarttime[p]["end_date"] ==undefined)
				   ) {
					 datearraystarttime[p]['show_start_from'] = defaultstarttime;
					 datearraystarttime[p]["sent_start_from"]=defaultstarttime.format(format);
				   }
				
			   }
			//    setIsTimePickerClosedstart(false)

			//    changestarttime = false;
			//    setchangestarttime(false)
			//    isTimePickerClosed(false)
			//    setClicked(false)
			}
			else if(type == "end_from"){
				// alert("bbbbbbbbbbb")

				NozzleAmount[i]["end_from"]=e;
				NozzleAmount[i]["sent_end_from"] = e.format(format);
				let datearrayendtime = NozzleAmount;

                for (let w = 0; w < datearrayendtime.length; w++) {
					
				if (
					changeendtime == true 
						 &&  
						 isTimePickerClosedend != true &&
						 
					   (w != i)
					   && (datearrayendtime[w]["end_date"] == null || datearrayendtime[w]["end_date"] ==undefined)
				   ) {
					// datearrayendtime[w]['end_from'] = defaultendtime;
					datearrayendtime[w]["end_from"] = e;
					datearrayendtime[w]["sent_end_from"] = e.format(format);
					
					   
				   }
				
				   
			   }
			//    setchangeendtime(false)
			//    setClicked(false)
			}
			else if(type=="end"){
				
				NozzleAmount[i]["endDate"]=e;


				
			}
			
			// else{
			// 	NozzleAmount[i]["endDate"]=e;
			// }


		
		


		}
		
		

	/**********/ 
	for (let k=0 ; k< NozzleAmount.length; k++)
	{

	   let startdateeee=NozzleAmount[k]["op_date"]
	   let startTime=NozzleAmount[k]["sent_start_from"]
	   let enddateeee=NozzleAmount[k]["endDate"]
	   let endtimeee=NozzleAmount[k]["sent_end_from"]
	   let formIsValid = true

	   if(startdateeee && startTime && enddateeee && endtimeee){

		   
		   if((NozzleAmount[k]['sent_end_from'] < NozzleAmount[k]['sent_start_from']) 
		   && (NozzleAmount[k]['endDate'] == NozzleAmount[k]['op_date'])
		   ){
		   
			   mulerror[k]['end_from_error'] = "On same date,end time should be greater than start time.";
			   formIsValid = false
			   setDouble(true)
			   
		   }else{
			   mulerror[k]['end_from_error']="";
		   }



		   if(formIsValid == true){

		   
	   
   /****************/ 

	   const trimmedStartTime = startTime.trim();
	   const startTimeWithSeconds = `${trimmedStartTime}:00`;
	   const startDateTimeString = `${startdateeee}T${startTimeWithSeconds}`;
	   const startDateTime = new Date(startDateTimeString);
		
/*********************/ 

/*************/ 

	   const trimmedendTime = endtimeee.trim();
	   const endTimeWithSeconds = `${trimmedendTime}:00`;
	   const endDateTimeString = `${enddateeee}T${endTimeWithSeconds}`;
	   const endDateTime = new Date(endDateTimeString);
	   const timeDifference = Math.abs(endDateTime - startDateTime);
			
	   // if (endtimeee < startTime) {
	   // 	// return { hours: 0, minutes: 0 }; 
	   // 	NozzleAmount[i]["sent_end_from"] = NozzleAmount[i]["sent_start_from"]
	   //   }

	 const totalHours = Math.floor(timeDifference / (1000 * 60 * 60));
const totalMinutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

NozzleAmount[k]["total_hr"] = isNaN(totalHours) ? 0 : totalHours;
NozzleAmount[k]["total_min"] = isNaN(totalMinutes) ? 0 : totalMinutes;

const formattedDifference = `${NozzleAmount[k]["total_hr"]} hr ${NozzleAmount[k]["total_min"]} min`;

NozzleAmount[k]["total_diff"] = formattedDifference;


/**************/ 
		   }else{
			   NozzleAmount[k]["total_hr"]=0;
			   NozzleAmount[k]["total_min"]=0;
		   }

	   }else{
	   NozzleAmount[k]["total_hr"]=0;
	   NozzleAmount[k]["total_min"]=0;
	   
	   }
	   

/*cal for end*/ 
	}
	/*********/ 
	// multiplevalidationform() 
		// if(e.target.name =='end_form'){
		// 	let end_time = e.target.value || NozzleAmount[i]['sugest_end_from']
		// 	NozzleAmount[i]['end_from'] = end_time;
		// }
		setTimePickerClicked(true);
        setMulerror(mulerror)
		setValues(NozzleAmount)
	}

function multiplevalidationform(){
	
		let formIsValid = true
		let validationdata=[]
		validationdata =[...Values]
	
	
		for (var i = 0; i < validationdata.length; i++) {
			// alert(validationdata[i]['quantity'] == '')
			// alert(isNaN(validationdata[i]["clossing_reading"]) == true )
			if(validationdata[i]['clossing_reading'] == null 
			
			|| validationdata[i]['clossing_reading'] == undefined  || 
			isNaN(validationdata[i]["clossing_reading"]) == true){
	
				mulerror[i]["close_reading_error"] = "Please enter the closing reading"; 
				formIsValid = false 
				setDouble(true)
																											  
			}else if(Number(validationdata[i]['clossing_reading']) < (Number(validationdata[i]["open_reading"]))){
			
				mulerror[i]["close_reading_error"] = "Closing Reading must greater than or equal to Opening Readings"; 
				formIsValid = false 
				setDouble(true)
			}
			else{
	
				mulerror[i]["close_reading_error"] = ""; 
	
			}

	if(validationdata[i]["sent_start_from"] == null || validationdata[i]["sent_start_from"] == undefined || validationdata[i]["sent_start_from"] == ''){
		mulerror[i]['start_from_error'] = "Enter start time";
		formIsValid = false
		setDouble(true)
	}else{
		mulerror[i]['start_from_error']="";
	}

	if(validationdata[i]["sent_end_from"] == null || validationdata[i]["sent_end_from"] == undefined || validationdata[i]["sent_end_from"] == ''){
		mulerror[i]['end_from_error'] = "Enter end time";
		formIsValid = false
		setDouble(true)
	}else{
		mulerror[i]['end_from_error']="";
	}

	if(validationdata[i]['endDate'] != null){
		
		mulerror[i]['end_date_error'] = "";
					
		    if((validationdata[i]['sent_end_from'] < validationdata[i]['sent_start_from']) 
					&& (validationdata[i]['endDate'] == validationdata[i]['op_date'])
					){
					
						mulerror[i]['end_from_error'] = "On same date,end time should be greater than start time.";
						formIsValid = false
						setDouble(true)
						
					}else{
						mulerror[i]['end_from_error']="";
					}
	}else{
		                mulerror[i]['end_date_error'] = "Enter End Date";
						formIsValid = false
						setDouble(true)
	}

	
			 if(!isNonNegativeNumber(validationdata[i]['quantity'])){
		
				mulerror[i]['quanity_error'] ="Please enter the Quantity";
				formIsValid = false
				setDouble(true)
				
			 }
			//  else if(validationdata[i]['quantity'] == ''){
			// 	// mulerror[i]['quanity_error'] ="Please enter the Quantity";
			// 	// formIsValid = false
			//  }
			 else{
				mulerror[i]['quanity_error'] ="";
			 }
			 
			  if(!isNonNegativeNumber(validationdata[i]['quantity'])){
		
				mulerror[i]['quanity_error'] ="Please enter the Quantity";
				formIsValid = false
				setDouble(true)
				
			 }
			//  else if(validationdata[i]['quantity'] == ''){
			// 	// mulerror[i]['quanity_error'] ="Please enter the Quantity";
			// 	// formIsValid = false
			//  }
			 else{
				mulerror[i]['quanity_error'] ="";
			 }
	
	
			//  alert(validationdata[i]['amount'])
			 if(!isNonNegativeNumber(validationdata[i]['amount'])){
				
				mulerror[i]['amount_error'] ="Please enter the amount"
				formIsValid = false
				setDouble(true)
			 }
			//  else if(validationdata[i]['amount'] == ''){
			// 	// mulerror[i]['amount_error'] ="Please enter the amount"
			// 	// formIsValid = false
			//  }
			 else{
				mulerror[i]['amount_error'] ="";
			 }

			 var check_qty = 0;
			 if (Number(validationdata[i]['quantity']) > Number(validationdata[i]['quantity_saved'])) {
				 check_qty = Number(validationdata[i]['quantity']) - Number(validationdata[i]['quantity_saved'])
			 }
			  var closingstock = 0;
			 if (Number(validationdata[i]['current_stock']) < check_qty) {
				 formIsValid = false;
				 setDouble(true)
				 var closingstock = 1;
				 mulerror[i]['current_stock_error'] = "Insufficient Quantity of fuel in the tank"
			 }
			 else {
				var closingstock = 0;
				mulerror[i]['current_stock_error'] = ""
				
			 }
			
			// if(validationdata[i].closing_stock != null && validationdata[i].closing_stock !== "" && validationdata[i].closing_stock !== 0){console.log("1");
            //  if (Number(validationdata[i]['closing_stock']) < check_qty) {console.log(validationdata[i]['closing_stock']);console.log(check_qty);console.log(2);
			// 	 formIsValid = false;
			// 	 setDouble(true)
			// 	 var closingstock = 1;
			// 	mulerror[i]['current_stock_error'] = "Insufficient quantity which exceeds available stock. Verify closing stock or recent purchase."
			//  }
			//  else {
			// 	if(closingstock == 0){
			// 	mulerror[i]['current_stock_error'] = ""
			//     }
			//  }
			//  }
	
			//  if(Number(validationdata[i]['current_stock']) <(Number( validationdata[i]['quantity']))){
			// 	mulerror[i]['current_stock_error'] ="Insufficient Quantity of fuel in the tank"
			// 	formIsValid=false
			// 	setDouble(true)
			//  }
			//  else{
			// 	mulerror[i]['current_stock_error'] ="";
			//  }
	
	
	
		
		}
		// setErrors(errors)
		// formIsValid = false
		setMulerror(mulerror)
		setValues(validationdata)
		return formIsValid;
	 }
	function check_url() {
		const requestOptions = {
			method: 'post',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"
			},
			body: JSON.stringify({
				pathurl: window.location.pathname,
			}),
		};
		fetch(`${API_URL}/check_url`, requestOptions)
			.then(response => { return response.json(); })

			.then(responseData => {
				applyCheckUrlNavigation(history, responseData, window.location.pathname, () => {
					check_meta_date()
				});

				return responseData;
			})
			.catch(e => {
			});

	}


	const handleSearch = (event) => {
		setSearch(event.target.value)
	}
	// ---handlesubmit function---//
	const handleSubmit = (event) => {
		//event.preventDefault();
		//	alert(2);
		setDouble(false);
		if (validateForm()) {
			sendBankData();
		}


	}
	//---validations---//	
	function validateForm() {
		let errors = []
		let formIsValid = true

		if (Number(inputValues.clossing_reading) < 0) {
			setDouble(true)
			formIsValid = false;
			errors["clossing_reading"] = "Enter Clossing Reading"
		}
		else if (Number(opening_reading.reading) > Number(inputValues.clossing_reading)) {
			formIsValid = false;
			setDouble(true)
			errors["clossing_reading"] = "Closing Reading must greater than Opening Reading"
		}
		else if (inputValues.nz_close_reading && Number(inputValues.clossing_reading) > Number(inputValues.nz_close_reading)) {
			formIsValid = false;
			setDouble(true)
			errors["clossing_reading"] = "Maximum alloved reading";
		}
		else {
			errors["clossing_reading"] = ""
		}
		const resolvedEndClock = resolveNozzleEndClock(inputValues.end_from, inputValues.sugest_end_from);
		const resolvedStartClock = resolveNozzleStartClock(inputValues.show_start_from, inputValues.start_from);
		if (!resolvedEndClock) {
			formIsValid = false;
			setDouble(true)
			errors["end_from"] = "Enter End Time"
		}
		else {
			errors["end_from"] = ""
		}
		if (!isNonNegativeNumber(inputValues.quantity)) {
			formIsValid = false;
			setDouble(true)
			errors["quantity"] = "Enter Quantity"
		}
		else {
			errors["quantity"] = ""
		}
		var check_qty = 0;
		if (Number(inputValues.quantity) > Number(inputValues.quantity_saved)) {
			check_qty = Number(inputValues.quantity) - Number(inputValues.quantity_saved)
		}
		
		if (Number(inputValues.current_stock) < check_qty) {
			formIsValid = false;
			setDouble(true)
			errors["quantity"] = "Insufficient Quantity of fuel in the tank"
		}
		else {
			errors["quantity"] = ""
		}

		if (!isNonNegativeNumber(inputValues.amount)) {
			formIsValid = false;
			setDouble(true)
			errors["amount"] = "Enter Amount"
		}
		else {
			errors["amount"] = ""
		}


		if (inputValues.endDate == inputValues.op_date) {
			const sameDayError = sameDayNozzleCloseTimeError(resolvedStartClock, resolvedEndClock);
			if (sameDayError && sameDayError !== 'Enter End Time') {
				formIsValid = false;
				setDouble(true)
				errors["end_from"] = sameDayError;
				errors["show_start_from"] = "";
			}
			else if (!sameDayError) {
				errors["show_start_from"] = "";
			}
		}
		else {
			errors["show_start_from"] = "";
		}

		// console.log(inputValues.show_start_from ,"inputValues.show_start_from ")
		// console.log( inputValues.end_from ," inputValues.end_from ")
		// console.log(inputValues.endDate  ,"inputValues.endDate  ")
		// console.log(inputValues.op_date ,"inputValues.op_date  ")

	
		if(inputValues.endDate == null){
			formIsValid = false;
			setDouble(true)
			errors["endDate"] = "select end date"
		}
		else {
			errors["endDate"] = ""
		}
		setErrors(errors)

		return formIsValid;
	}

	const handleSubmit1 = (event) => {
		//event.preventDefault();
		
		 setDouble(false);
		if (multiplevalidationform()) {
		
			
			 sendBankDataallnozzle();
			//  alert(123)
		}


	}
	function sendBankData(zeroQuantityReason = null) {
		const endClock = resolveNozzleEndClock(inputValues.end_from, inputValues.sugest_end_from);
		const startClock = resolveNozzleStartClock(inputValues.show_start_from, inputValues.start_from);
		if (!endClock) {
			setDouble(true);
			return;
		}
		const endTime = endClock.format('HH:mm:ss');
		const startTime = startClock ? startClock.format('HH:mm:ss') : null;
		const qty = parseFloat(inputValues.quantity) || 0;
		let reason = zeroQuantityReason;
		if ((reason === null || reason === undefined || reason === '') && inputValues.nz_count === 'Yes2' && qty <= 0.01) {
			reason = 'post-unload lock';
		}

		const payload = {
				amount: toFixedNumberString(inputValues.amount, 2),
				b_opening_reading: inputValues.b_opening_reading,
				b_selling_price: inputValues.b_selling_price,
				clossing_reading: toFixedNozzleReading(inputValues.clossing_reading),
				comma: inputValues.comma,
				current_stock: inputValues.current_stock,
				end_from: endTime,
				sent_end_from: endTime,
				id: inputValues.id,
				endDate:inputValues.endDate,
				total_hr:inputValues.total_hr,
				total_min:inputValues.total_min,
				op_emp_id: inputValues.op_emp_id,
				price: inputValues.price,
				start_from: formatNozzleClock(inputValues.start_from) || startTime,
				op_date: localStorage.getItem('op_date'),
				product_id: inputValues.product_id,
				quantity: toFixedNumberString(inputValues.quantity, 2),
				sugest_end_from: formatNozzleClock(inputValues.sugest_end_from),
				show_start_from: startTime,
		};
		if (reason) {
			payload.zero_quantity_reason = reason;
		}

		const requestOptions = {
			method: 'POST',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"
			}, body: JSON.stringify(payload)
		
		};
		fetch(API_URL + "/nozzle_closing", requestOptions)
			.then(response => {
				return response.json();
			})
			.then(responseData => {

				if (responseData.status == false) {
					errors["name"] = responseData.response.name
					errors["amount"] = responseData.response.amount
					setDouble(true)
				}
				if (responseData.status == "DENY") {
					toggle();
					swal("", responseData.message, responseData.status ? "warning" : "warning")
					setDouble(true)
				}
				if (responseData.status == 3) {
					if (responseData.needs_confirm && responseData.confirm_field === 'zero_quantity_reason') {
						const prompted = window.prompt(
							(responseData.message || 'Meter moved but 0 L billed.') +
							'\n\nEnter a reason to continue (Cancel to abort):'
						);
						if (prompted && prompted.trim() !== '') {
							sendBankData(prompted.trim());
							return responseData;
						}
						setDouble(true);
						return responseData;
					}
					swal("", responseData.message || "Unable to close nozzle", "warning");
					setDouble(true);
				}
				if (responseData.status == true) {
					swal("", responseData.message, responseData.status ? "success" : "warning")
					history.push("/nozzle-closing")
					setDouble(true)
					toggle();
					check_meta_date();
				}
				setErrors(errors)
				return responseData;
			})
			.catch(e => {

				setDouble(true)
			});
	}

	function sendBankDataallnozzle(reasonById = null) {
		const rows = Values.map((row) => {
			const qty = parseFloat(row.quantity) || 0;
			const payload = {
				...row,
				open_reading: toFixedNozzleReading(row.open_reading),
				clossing_reading: toFixedNozzleReading(row.clossing_reading),
				quantity: toFixedNumberString(row.quantity, 2),
				amount: toFixedNumberString(row.amount, 2),
			};
			if (reasonById && reasonById[row.id]) {
				payload.zero_quantity_reason = reasonById[row.id];
			} else if (row.nz_count === 'Yes2' && qty <= 0.01) {
				payload.zero_quantity_reason = 'post-unload lock';
			}
			return payload;
		});

		const requestOptions = {
			method: 'POST',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"
			}, body: JSON.stringify({
				array: rows,
			})
		
		};


		fetch(API_URL + "/mul_nozzle_closing", requestOptions)
			.then(response => {
				return response.json();
			})
			.then(responseData => {

				if (responseData.status == false) {
					errors["name"] = responseData.response.name
					errors["amount"] = responseData.response.amount
					setDouble(true)
				}
				if (responseData.status == "DENY") {
					toggle_allnozzle();
					swal("", responseData.message, responseData.status ? "warning" : "warning")
					setDouble(true)
				}
				if (responseData.needs_confirm && responseData.confirm_field === 'zero_quantity_reason') {
					const prompted = window.prompt(
						(responseData.message || 'Meter moved but 0 L billed.') +
						'\n\nEnter a reason to continue (Cancel to abort):'
					);
					if (prompted && prompted.trim() !== '') {
						const nextReasons = { ...(reasonById || {}) };
						Values.forEach((row) => {
							const qty = parseFloat(row.quantity) || 0;
							const open = parseFloat(row.open_reading || row.opening_reading) || 0;
							const close = parseFloat(row.clossing_reading) || 0;
							if (qty <= 0.01 && close > open + 0.01 && !nextReasons[row.id]) {
								nextReasons[row.id] = prompted.trim();
							}
						});
						sendBankDataallnozzle(nextReasons);
						return responseData;
					}
					setDouble(true);
					return responseData;
				}
				if (responseData.status == 3) {
					swal("", responseData.message || "Unable to close nozzles", "warning");
					setDouble(true);
				}
				if (responseData.status == true) {
					swal("", responseData.message, responseData.status ? "success" : "warning")
					history.push("/nozzle-closing")
					setDouble(true)
					toggle_allnozzle();
					check_meta_date();
				}
				setErrors(errors)
				return responseData;
			})
			.catch(e => {

				setDouble(true)
			});
	}


	
// 	function add_nozzle_clossing_all(nozzle_name=null) {

// alert(single_id);
// 	}
	function add_nozzle_clossing_all() {
		setErrors([])
		const requestOptions = {
			method: 'POST',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"
			}, body: JSON.stringify({
				op_date: localStorage.getItem('op_date'),
				id :single_id,
				nozzle_name: '',
			})
		};
		fetch(API_URL + "/get_all_product_price", requestOptions)
			.then(response => {
				return response.json();
			})
			.then(responseData => {
              

				// if (responseData.status == false) {
				// 	errors["name"] = responseData.response.name
				// }
				// setErrors([''])
				let Nozzle=[]
				let mulerror=[]
				let olddatatime=[]
			
				responseData.forEach((elem, index) => {
               
					mulerror.push({
						close_reading_error:"",
						quanity_error:"",
						amount_error:"",
						end_from_error:"",
						end_date_error:"",
						start_from_error:"",

					            })

					
					const apiDate = elem.op_date;
					const apiDateObj = new Date(apiDate);
				
					apiDateObj.setDate(apiDateObj.getDate() + 2);
					const updatedApiDateISO = apiDateObj.toISOString();

					// Extract the relevant part of the string to match the format of the original apiDate
					const updatedApiDate = updatedApiDateISO.substring(0, 10);


					 
					
					if (elem.endDate !== null && 
						elem.endDate !== undefined &&
						elem.sugest_end_from !== null && 
						elem.sugest_end_from !== undefined &&
						elem.op_date !== null && 
						elem.op_date !== undefined &&
						elem.show_start_from !== null && 
						elem.show_start_from !== undefined) {
						 
							let resstartdateeee=elem.op_date
							let resstartTime=elem.show_start_from
							let resenddateeee=elem.end_date?elem.end_date:elem.op_date
							let resendtimeee=elem.sugest_end_from

						
							/*************/ 
							
							let formIsValid = true
					 
							if(resstartdateeee && resstartTime && resenddateeee && resendtimeee
								&&((elem.end_date == null || elem.end_date ==undefined))
								){
					 
								
								if((elem.sugest_end_from < elem.show_start_from) 
								&& (elem.endDate == elem.op_date)
								){
								
									mulerror[index]['end_from_error'] = "On same date,end time should be greater than start time.";
									formIsValid = false
									setDouble(true)
									
								}else{
									mulerror[index]['end_from_error']="";
								}
					 
					 
					 
								if(formIsValid == true){
					 
								
							
						/****************/ 
					 
							const restrimmedStartTime = resstartTime.trim();
							const resstartTimeWithSeconds = `${restrimmedStartTime}`;
							const resstartDateTimeString = `${resstartdateeee}T${resstartTimeWithSeconds}`;
							const resstartDateTime = new Date(resstartDateTimeString);
							 
					 /*********************/ 
					 
					 /*************/ 
					 
							const restrimmedendTime = resendtimeee.trim();
							const resendTimeWithSeconds = `${restrimmedendTime}`;
							const resendDateTimeString = `${resenddateeee}T${resendTimeWithSeconds}`;
							const resendDateTime = new Date(resendDateTimeString);
							const timeDifference = Math.abs(resendDateTime - resstartDateTime);
								 
							// if (endtimeee < startTime) {
							// 	// return { hours: 0, minutes: 0 }; 
							// 	NozzleAmount[i]["sent_end_from"] = NozzleAmount[i]["sent_start_from"]
							//   }
					 
							const restotalHours = Math.floor(timeDifference / (1000 * 60 * 60));
							const restotalMinutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
							elem.total_hr=restotalHours;
							elem.total_min=restotalMinutes;
							// const resformattedDifference = `${restotalHours}hr ${restotalMinutes}min`;
							//  console.log(resformattedDifference,"resformattedDifference")
							//  NozzleAmount[k]["total_diff"]=resformattedDifference;
					 
					 /**************/ 
								}else{
									elem.total_hr=0;
									elem.total_min=0;
								}
					 
							}else{
								elem.total_hr=elem.total_hr != null ? elem.total_hr : 0;
								elem.total_min=elem.total_min != null ? elem.total_min : 0;
							}
					}

					
				
					// const maxDate = nextTwoDays.toISOString().split('T')[0];
					const openReading = elem.opening_reading;
					const closingReading = elem.close_reading;
					const sellPrice = elem.selling_price || elem.price || '';
					const hasClosing =
						closingReading !== null &&
						closingReading !== undefined &&
						closingReading !== '' &&
						Number.isFinite(parseFloat(closingReading));
					const roundedSale = hasClosing
						? calcRoundedNozzleSale({
							closingReading,
							openReading,
							price: sellPrice,
							bOpeningReading: elem.b_opening_reading,
							bSellingPrice: elem.b_selling_price,
						})
						: {
							quantity: elem.quantity != null && elem.quantity !== ''
								? toFixedNumberString(elem.quantity, 2)
								: '',
							amount: elem.amount != null && elem.amount !== ''
								? toFixedNumberString(elem.amount, 2)
								: '',
						};
					  Nozzle.push({
							end_from:elem.end_from != null ? moment(elem.end_from, 'HH:mm:ss') : null,
						    sent_end_from:elem.end_from != null ? moment(elem.end_from, 'HH:mm:ss').format(format) : moment(elem.sugest_end_from, 'HH:mm:ss').format(format),
			                sugest_end_from:elem.sugest_end_from != '' ? moment(elem.sugest_end_from, 'HH:mm:ss') : null,
							clossing_reading: closingReading != null && closingReading !== ''
								? toFixedNozzleReading(closingReading)
								: closingReading,
						    b_opening_reading:elem.b_opening_reading,
						    b_selling_price:elem.b_selling_price,
						    comma:elem.b_selling_price != '' ? ',' : '',
							quantity: roundedSale.quantity,
							quantity_saved: roundedSale.quantity !== '' ? roundedSale.quantity : elem.quantity,
							amount: roundedSale.amount,
							op_date: elem.op_date,
							end_date: elem.end_date,
							endDate:elem.end_date == null ? elem.op_date  : elem.end_date,
							product_id:elem.fuel_p_id,
							// price:elem.saved_price,
							current_stock:elem.current_stock,
							nozzle_id:elem.nozzle_id,
							nozzle_status:elem.nozzle_status,
							nz_close_reading:elem.nz_close_reading,
							total_diff:elem.total_diff,
							total_hr:elem.total_hr != null? elem.total_hr :0,
							total_min:elem.total_min !=null? elem.total_min:0,
							// nz_count:elem.nz_count,
							nz_count:elem.nz_count,
							start_from:elem.start_from != '' ? moment(elem.start_from, 'HH:mm:ss') : null,
						    op_emp_id:elem.op_emp_id,
							nozzle_name:elem.nozzle_name,
				            open_reading:elem.opening_reading,
							price: sellPrice,
							end_date_max:updatedApiDate,
							id:elem.id,
							show_start_from:elem.show_start_from!= null ? moment(elem.show_start_from, 'HH:mm:ss') : null,
							sent_start_from: elem.show_start_from!= null ? (moment(elem.show_start_from, 'HH:mm:ss')).format(format):(moment(elem.start_from, 'HH:mm:ss')).format(format),
					        closing_stock:elem.closing_stock!= null ? elem.closing_stock : null,

					})

					olddatatime.push({
						op_date: elem.op_date,
						show_start_from:elem.show_start_from!= null ? moment(elem.show_start_from, 'HH:mm:ss') : null,
						sent_start_from: elem.show_start_from!= null ? (moment(elem.show_start_from, 'HH:mm:ss')).format(format):(moment(elem.start_from, 'HH:mm:ss')).format(format),
						end_from:elem.end_from != null ? moment(elem.end_from, 'HH:mm:ss') : null,
						sent_end_from:elem.end_from != null ? moment(elem.end_from, 'HH:mm:ss').format(format) : moment(elem.sugest_end_from, 'HH:mm:ss').format(format),
						sugest_end_from:elem.sugest_end_from != '' ? moment(elem.sugest_end_from, 'HH:mm:ss') : null,


					})
                      
					
					


				})
				 setMulerror(mulerror)
				 setValues(Nozzle)
				 setValuess(olddatatime)
				 //setStock(closingstock)

				 
				 toggle_allnozzle();
				// responseData.foreach((elem.index))


				})

			.catch(e => {

			});
	}


	//---Edit employee list---//	
	function applyClosingPriceResponse(responseData) {
		const hasSplitPrice = responseData.b_selling_price != null
			&& responseData.b_selling_price !== ''
			&& responseData.b_selling_price != responseData.selling_price;

		setPrice({ price: responseData.selling_price });
		setInputValues(prev => {
			const next = {
				...prev,
				b_selling_price: responseData.b_selling_price || '',
				comma: hasSplitPrice ? ',' : '',
				price: responseData.selling_price,
			};

			if (prev.clossing_reading && opening_reading.reading != null && responseData.selling_price) {
				const q = Math.max(0, Number(prev.clossing_reading) - Number(opening_reading.reading));
				const qFixed = parseFloat(q.toFixed(2));

				if (prev.clossing_reading <= prev.b_opening_reading
					&& responseData.b_selling_price
					&& prev.b_opening_reading) {
					next.quantity = qFixed.toFixed(2);
					next.amount = (qFixed * responseData.b_selling_price).toFixed(2);
				} else if (prev.clossing_reading > prev.b_opening_reading
					&& responseData.b_selling_price
					&& prev.b_opening_reading) {
					const bQty = prev.b_opening_reading - opening_reading.reading;
					const qty = prev.clossing_reading - prev.b_opening_reading;
					next.quantity = qFixed.toFixed(2);
					next.amount = (
						(responseData.b_selling_price * bQty)
						+ (responseData.selling_price * qty)
					).toFixed(2);
				} else {
					next.quantity = qFixed.toFixed(2);
					next.amount = (qFixed * responseData.selling_price).toFixed(2);
				}
			}

			return next;
		});
	}

	function refreshClosingPrice(id, endFromMoment, endDate) {
		if (!id || !endFromMoment) {
			return;
		}

		const requestOptions = {
			method: 'POST',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"
			},
			body: JSON.stringify({
				op_date: localStorage.getItem('op_date'),
				id: id,
				sent_end_from: endFromMoment.format('HH:mm:ss'),
				endDate: endDate || localStorage.getItem('op_date'),
			})
		};

		fetch(API_URL + "/get_product_price", requestOptions)
			.then(response => response.json())
			.then(responseData => {
				if (responseData.selling_price) {
					applyClosingPriceResponse(responseData);
				}
			})
			.catch(() => {});
	}

	function add_nozzle_clossing(id,nozzle_name=null) {
		setErrors([])
		const requestOptions = {
			method: 'POST',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"
			}, body: JSON.stringify({
				op_date: localStorage.getItem('op_date'),
				id: id,
				nozzle_name: nozzle_name,
			})
		};
		fetch(API_URL + "/get_product_price", requestOptions)
			.then(response => {


				return response.json();
			})
			.then(responseData => {


				if (responseData.endDate !== null && 
					responseData.endDate !== undefined &&
					responseData.sugest_end_from !== null && 
					responseData.sugest_end_from !== undefined &&
					responseData.op_date !== null && 
					responseData.op_date !== undefined &&
					responseData.show_start_from !== null && 
					responseData.show_start_from !== undefined) {
					 
						let resstartdateeee=responseData.op_date
						let resstartTime=responseData.show_start_from
						let resenddateeee=responseData.end_date?responseData.end_date:responseData.op_date
						let resendtimeee=responseData.sugest_end_from

					
						/*************/ 
						
						let formIsValid = true
				 
						if(resstartdateeee && resstartTime && resenddateeee && resendtimeee
							&&((responseData.end_date == null || responseData.end_date ==undefined))
							){
				//  alert(1)
							
							if((responseData.sugest_end_from < responseData.show_start_from) 
							&& (responseData.endDate == responseData.op_date)
							){
								errors["end_from"] ="On same date,End time should be greater than start time";
								formIsValid = false
								setDouble(true)
								
							}else{
								errors["end_from"]="";
							}
				 
				 
				 
							if(formIsValid == true){
				 
							
						
					/****************/ 
				 
						const restrimmedStartTime = resstartTime.trim();
						const resstartTimeWithSeconds = `${restrimmedStartTime}`;
						const resstartDateTimeString = `${resstartdateeee}T${resstartTimeWithSeconds}`;
						const resstartDateTime = new Date(resstartDateTimeString);
						 
				 /*********************/ 
				 
				 /*************/ 
				 
						const restrimmedendTime = resendtimeee.trim();
						const resendTimeWithSeconds = `${restrimmedendTime}`;
						const resendDateTimeString = `${resenddateeee}T${resendTimeWithSeconds}`;
						const resendDateTime = new Date(resendDateTimeString);
						const timeDifference = Math.abs(resendDateTime - resstartDateTime);
							 
						// if (endtimeee < startTime) {
						// 	// return { hours: 0, minutes: 0 }; 
						// 	NozzleAmount[i]["sent_end_from"] = NozzleAmount[i]["sent_start_from"]
						//   }
				 
						const restotalHours = Math.floor(timeDifference / (1000 * 60 * 60));
						const restotalMinutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
						responseData.total_hr=restotalHours;
						responseData.total_min=restotalMinutes;
						// const resformattedDifference = `${restotalHours}hr ${restotalMinutes}min`;
						//  console.log(resformattedDifference,"resformattedDifference")
						//  NozzleAmount[k]["total_diff"]=resformattedDifference;
				 
				 /**************/ 
							}else{
								responseData.total_hr=0;
								responseData.total_min=0;
							}
				 
						}else{
							responseData.total_hr=responseData.total_hr != null ? responseData.total_hr : 0;
							responseData.total_min=responseData.total_min != null ? responseData.total_min : 0;
						}
				}


				const apiDatee = responseData.op_date;
				const apiDateeObj = new Date(apiDatee);
			
				apiDateeObj.setDate(apiDateeObj.getDate() + 2);
				const updatedApiDateeISO = apiDateeObj.toISOString();

				// // Extract the relevant part of the string to match the format of the original apiDate
				const updatedApiDatee = updatedApiDateeISO.substring(0, 10);
				// alert(1)
				// {console.log(updatedApiDatee,"take")}

				if (responseData.status == false) {
				errors["name"] = responseData.response.name
				}

				setErrors([''])
				const suggestedEnd = resolveNozzleEndClock(null, responseData.sugest_end_from);
				const savedEnd = resolveNozzleEndClock(responseData.end_from, null);
				setInputValues({
					...inputValues,
					id: id,
					end_from: savedEnd || suggestedEnd,
					sugest_end_from: suggestedEnd,
					clossing_reading: responseData.close_reading,
					b_opening_reading: responseData.b_opening_reading,
					b_selling_price: responseData.b_selling_price,
					comma: responseData.b_selling_price != '' && responseData.b_selling_price != responseData.selling_price ? ',' : '',
					quantity: responseData.quantity,
					quantity_saved: responseData.quantity,
					amount: responseData.amount,
					price: responseData.selling_price || responseData.saved_price,
					end_datee_max:updatedApiDatee,
					current_stock: responseData.current_stock,
					nozzle_status: responseData.nozzle_status,
					op_date:responseData.op_date,
					// endDate: responseData.op_date,
					// endDate:endDate != null ? responseData.endDate : null,
					endDate:responseData.end_date == null ? responseData.op_date  : responseData.end_date,
					nz_close_reading: responseData.nz_close_reading,
					nz_count: responseData.nz_count,
					total_hr:responseData.total_hr != null? responseData.total_hr :0,
					total_min:responseData.total_min !=null? responseData.total_min:0,
					total_diff:responseData.total_diff,
					// total_hr:responseData.total_hr != null? responseData.total_hr :0,
					// total_min:responseData.total_min !=null? responseData.total_min:0,
					show_start_from: resolveNozzleStartClock(responseData.show_start_from, responseData.start_from),
					start_from: resolveNozzleStartClock(responseData.start_from, null),
					op_emp_id: localStorage.getItem('op_emp_id'),
					closing_stock: responseData.closing_stock
				})
				const nozzle_name=responseData.nozzle_name
				const open_reading=responseData.opening_reading
				localStorage.setItem('nozzle_name',nozzle_name)
				localStorage.setItem('opening_reading',open_reading)
				setPrice({ price: responseData.selling_price })
				setProduct({ product_id: responseData.fuel_p_id })
				setOpeningReading({ reading: responseData.opening_reading })
				setErrors(errors)
				toggle();
				return responseData;
			})
			.catch(e => {

			});
	}

	function calculatehours() {
 
		// alert(1)
	}

	///////////////

	return (
		<>
			<div className="main-container page-wrap">
				<div className="d-md-flex">
					<Sidebar_Progress props={props} progress={7} />
					<div className="content-area">
						<LoginHeaderOperational props={props} page_title="" />
						<div class="container pb-3 tab-view">
							<div class="row  mt-3 form-container">
								<div className="col-md-9">
									<TabHeader progress={13} />
									<div className="col-5">
										<div className="row">
											{Loading ? ListNozzleAllocation :
												// <div class="loader text-primary">Loading...</div>
												<Loader />
											}
										</div>
									</div>
									<div class="form-wrap ">




										<div class="tab-content" id="myTabContent">
											<div class="tab-pane fade show active" id="nozzleclosing" role="tabpanel" aria-labelledby="nozzleclosing-tab">
												<div class="">
													<div class="row mb-3">
														<div class="col-md">
															<div class="row">

															{
																	<div className="col-md col pl-0">
																	<h3 className="table-title">
																		Nozzle Closing ({localStorage.getItem("emp_name")})-
																		{moment(localStorage.getItem("op_date")).format("DD-MM-YYYY")}
																	</h3>
																	{/* <h4 className="table-title">
																		Shift Time : {localStorage.getItem("shift_time")}
																	</h4>
																	{list_data.length > 0 && (
																		<h4 className="table-title">
																		Total Worked Hours : 
																		{list_data[list_data.length - 1].total_hr}Hr 
																		{list_data[list_data.length - 1].total_min}Min
																		</h4>
																	)}*/}
																	</div>
																	}

																{/* <div className="col-md-12 mb-2"><Link to="/newnozzle-closing"><a href="newnozzle-closing" className="btn btn-primary bt-search btn-sm">CLOSE ALL NOZZLE</a></Link></div> */}
																<div className="col-md-12 mb-2" onClick={() => add_nozzle_clossing_all()}><a className="btn btn-primary bt-search btn-sm" >CLOSE ALL NOZZLE</a></div>
																
															</div>
														</div>
														<div class="col-md-4">
															<div class="input-group mb-3 search">
																<span class="input-group-text" id="basic-addon1"><i class="fa fa-search" aria-hidden="true"></i>
																</span>
																<input type="text" class="form-control" placeholder="Search" aria-label="Username" aria-describedby="basic-addon1" value={search.search_keyword} onChange={handleSearch}></input>
																<a className="btn btn-primary bt-search btn-sm" data-bs-target="#mla" onClick={check_url} >Submit</a>
															</div>

														</div>
													</div>


													<div class="table-widget">
														<table class="table border">
															<thead>
																<tr>
																	<th>Nozzle Name</th>
																	<th className="col-2">Start Time</th>
																	<th className="col-2">End Time</th>
																	<th>Opening Reading</th>
																	<th>Closing Reading</th>
																	<th >Quantity in Lt.</th>
																	<th>Price</th>
																	<th>Operation Date</th>
																	<th>Amount</th>
																	<th>Action</th>
																</tr>
															</thead>

															<tbody>
																{
																	list_data.map((obj) => (
																		<tr>
																			<td>{obj.nozzle_name}</td>
																			<td>{formatReportTime(obj.show_start_from || obj.start_from) || '—'}</td>
																			<td>{formatReportTime(obj.end_from) || (obj.end_from ? '—' : '')}</td>
																			<td>{obj.opening_reading}</td>
																			<td>{obj.close_reading}</td>
																			<td>{obj.quantity}</td>
																			<td>{obj.price}</td>
																			<td>{moment(obj.op_date).format("DD-MM-YYYY")}</td>
																			<td>{obj.amount}</td>
																			<td><div className="d-flex icon-btn">
																				<button onClick={() => add_nozzle_clossing(obj.id,obj.nozzle_name)}>  <i className="fa fa-ellipsis-h" aria-hidden="true"></i></button>
																			</div></td>
																		</tr>

																	))}
																
																<tr>
																	

																	<td colSpan={8} className="text-end mt-4"><b>Total Amount</b></td>
																	<td colSpan={2}>{total.totalamount}</td>
																</tr>
																

															</tbody>
														</table>
														<nav aria-label="Page navigation example">
															<ul className="pagination justify-content-end">
																{pages.total_pages > 1 && pages.pagination_items}
															</ul>
														</nav>

													</div>

												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="col-md-3">
									<SummarySheet summary={summary} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			{isShowing ? (<NozzleEmp
				isShowing={isShowing}
				hide={toggle}
				handleInputs={handleInputs}
				handleInput={handleInput}
				handlestartInput={handlestartInput}
				preventNonNumericalInput={preventNonNumericalInput}
				inputValues={inputValues}
				fields={fields}
				double={double}
				handleSubmit={handleSubmit}
				errors={errors}
			/>) : null
			}

          {isShowing1 ? (<NozzleEmpDesign
				isShowing1={isShowing1}
				hide={toggle_allnozzle}
				handleInputs={handleInputs}
				handleInput={handleInput}
				handleClose={handleClose}
				endDate={endDate}
				handleEndDateChange={handleEndDateChange}
				handleInput1={handleInput1}
				preventNonNumericalInput={preventNonNumericalInput}
				inputValues={inputValues}
				Values={Values}
				fields={fields}
				double={double}
				mulerror={mulerror}
				handleFocus={handleFocus}
				handleBlur={handleBlur}
				handleCloseAllFieldBlur={handleCloseAllFieldBlur}
				setTimePickerClicked={setTimePickerClicked}
				handleSubmit1={handleSubmit1}
				handleAmount={handleAmount}
				errors={errors}
			/>) : null
			}
		</>
	)
}








export default NozzleEmpConfig